import React from 'react'
import styled from 'styled-components'

import { shortDateTime } from 'helpers/formatters'

import { screenWidthBreakpoints } from 'styles/shared'
import { color } from 'styles/colors'

type Props = {
  date?: Date | null
}

const LastUpdated = ({ date }:Props) => (
  <S.Container>
    <S.Label>Last updated: </S.Label>
    <S.Date>{date ? shortDateTime(date) : 'UNKNOWN'}</S.Date>
  </S.Container>
)

export default LastUpdated

const S = {
  Container: styled.div`
    font-size: 11px;
    color: ${color('serviceContractNone')};
    font-weight: 400;
  `,
  Label: styled.span`
    line-height: 1.2;
    display: none;

    @media (min-width: ${screenWidthBreakpoints.devicePanelHeaderShortVersionBreakpoint}px) {
      display: unset;
    }
  `,
  Date: styled.span`
    white-space: wrap;
    text-align: right;
    line-height: 1.2;
  `
}
